const access = { all: "All", user: "User", admin: "Admin" };

export const menuList = [
  {
    icon: "home",
    label: "Home",
    separator: true,
    access: access.all,
    link: "/",
  },
  {
    icon: "flag",
    label: "Yellow Banner",
    separator: false,
    access: access.all,
    link: "/yellowBanner",
  },
  {
    icon: "tarp",
    label: "Preview Mode",
    separator: false,
    access: access.all,
    link: "/previewMode",
  },
  {
    icon: "ad",
    label: "Slides",
    separator: false,
    access: access.all,
    link: "/promos",
  },
  {
    icon: "gamepad",
    label: "Game Description",
    separator: false,
    access: access.all,
    link: "/gamesDescription",
  },
  {
    icon: "ad",
    label: "Priority Engagement Promo",
    separator: false,
    access: access.all,
    link: "/engagementPromo",
  },
  {
    icon: "bullhorn",
    label: "Cross Promotion",
    separator: false,
    access: access.all,
    link: "/crossPromotion",
  },
  {
    icon: "images",
    label: "Upload Images",
    separator: true,
    access: access.all,
    link: "/images",
  },
  {
    icon: "eraser",
    label: "Clear Cache",
    separator: false,
    access: access.admin,
    link: "/clearCache",
  },
];
